<app-nav></app-nav>
<div [ngSwitch]="routeVal">
    <div *ngSwitchDefault>
        <app-verification-list></app-verification-list>
    </div>
    <div *ngSwitchCase="'1'">
        <app-verify-document></app-verify-document>
    </div>
    <div *ngSwitchCase="'2'">
        <app-verification-list-dispute></app-verification-list-dispute>
    </div>
    <!-- <div *ngSwitchCase="'3'">
        <app-verify-document-edit></app-verify-document-edit>
    </div> -->
    <div *ngSwitchCase="'4'">
        <app-verify-edit-document></app-verify-edit-document>
    </div>
</div>
<app-footer></app-footer>